<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Vertical Space</span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="space-Vertical-slider"
        v-model="spaceVertical"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="spaceVerticalClasses"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { SpaceVerticalClasses } from '../classes/SpaceClasses'
  export default MenuStyleProperty.extend({
    computed: {
      spaceVerticalClasses() {
        return Object.keys(SpaceVerticalClasses)
      },
      spaceVertical: {
        get() {
          let currentSpaceVertical = this.elementClasses(this.classes)[this.device].find(elementClass => this.spaceVerticalClasses.includes(elementClass.value))
          if (! currentSpaceVertical) {
            currentSpaceVertical = {property: 'SpaceVertical', value: 'SPACE_XS', touched: false}
            this.addToArray(this.module, [currentSpaceVertical], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentSpaceVertical.value
        },
        set: _.debounce(function (value) {
          let currentSpaceVertical = this.elementClasses(this.classes)[this.device].find(elementClass => this.spaceVerticalClasses.includes(elementClass.value))
          value = {property: 'SpaceVertical', value: value, touched: currentSpaceVertical.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>